import { motion } from 'framer-motion';
import { Home, Users, Package, FileText, Phone } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom'; // Importar Link de react-router-dom



const handleWhatsAppRedirect = () => {
  const message = encodeURIComponent("Hola, necesito información sobre sus equipos médicos");
  window.open(`https://wa.me/18095551234?text=${message}`, '_blank');
};


const SitemapPage = () => {
  const siteStructure = [
    {
      title: "Páginas Principales",
      icon: <Home className="w-5 h-5" />,
      links: [
        { name: "Inicio", url: "/" },
        { name: "Testimonios", url: "/testimonials" },
        { name: "Historia", url: "/history" },
        { name: "Contacto", url: "/contact" },
        { name: "Carrito", url: "/cart" },
        { name: "Sobre Nosotros", url: "/about" },
        { name: "Catálogo Completo", url: "/products" },


      ]
    },
  
    
   
    {
      title: "Politicas y FAQS",
      icon: <FileText className="w-5 h-5" />,
      links: [
        { name: "FAQs", url: "/faqs" },
        { name: "Política de Privacidad", url: "/privacy" },
        { name: "Política de Devoluciones", url: "/return-policy" },
        { name: "Terminos", url: "/terms" },

      ]
    },
    
  ];

  return (
    <div className="min-h-screen bg-main-bg p-8">
      {/* Encabezado */}
      <div
        
        className="mb-12 text-center"
      >
        <h1 className="text-4xl md:text-5xl font-poppins font-bold text-dark mb-4">
          Mapa del Sitio
        </h1>
        <p className="text-dark font-montserrat max-w-2xl mx-auto">
          Explora toda nuestra estructura de contenido y servicios disponibles
        </p>
      </div>

      {/* Estructura del Sitio */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {siteStructure.map((section, index) => (
          <div
            key={index}
            
            className="bg-white rounded-xl shadow-lg p-6"
          >
            <div className="flex items-center mb-4">
              <div className="p-3 bg-primary/10 rounded-lg mr-3">
                {React.cloneElement(section.icon, { className: "w-6 h-6 text-primary" })}
              </div>
              <h2 className="text-xl font-poppins font-semibold text-dark">
                {section.title}
              </h2>
            </div>
            
            <ul className="space-y-3">
              {section.links.map((link, linkIndex) => (
                <motion.li
                  key={linkIndex}
                  whileHover={{ x: 5 }}
                  className="group"
                >
                  <Link
                    to={link.url} // Usar Link de react-router-dom
                    className="flex items-center text-dark hover:text-secondary transition-colors"
                  >
                    <span className="w-2 h-2 bg-primary rounded-full mr-3" />
                    <span className="font-montserrat hover:underline">
                      {link.name}
                    </span>
                  </Link>
                </motion.li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* CTA Final */}
      <div
        
        className="text-center mt-16 bg-section-bg p-8 rounded-2xl max-w-4xl mx-auto"
      >
        <h2 className="text-1xl md:text-3xl font-poppins font-bold text-dark mb-4">
          ¿No encuentras lo que buscas?
        </h2>
        <p className="text-dark font-montserrat mb-6">
          Nuestro equipo de soporte está disponible para ayudarte
        </p>
        <motion.button onClick={handleWhatsAppRedirect}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="bg-primary text-white px-8 py-4 rounded-xl font-poppins font-semibold"
        >
          Contactar Soporte
        </motion.button>
      </div>
    </div>
  );
};

export default SitemapPage;
